// src/forms-mailer.js
/* global bootstrap, gtag */
(function () {
  // Evita doble carga del archivo
  if (window.__FORMS_MAILER_INIT__) return;
  window.__FORMS_MAILER_INIT__ = true;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const PHONE_RE = /^\+?[0-9\s\-().]{6,20}$/;

  // Busca por name="campo" o por id que empiece con el nombre (name3, email2, etc.)
  const val = (form, name) =>
    form.querySelector(`[name="${name}"], [id^="${name}"]`);

  const markError = (el, on, cls) => {
    if (!el) return;
    const wrap =
      el.closest(".mb-3, .form-group, [class*='col-'], .col, .col-12") ||
      el.parentElement;
    el.classList.toggle(cls, on);
    if (wrap) wrap.classList.toggle(cls, on);
  };

  const validate = (form, required, errCls) => {
    let ok = true;
    required.forEach((key) => {
      const el = val(form, key);
      let bad = !el || !(el.value || "").trim();
      if (el && key === "email" && el.value) bad = bad || !EMAIL_RE.test(el.value.trim());
      if (el && key === "phone" && el.value) bad = bad || !PHONE_RE.test(el.value.trim());
      markError(el, bad, errCls);
      ok = ok && !bad;
    });
    return ok;
  };

  const toggleSending = (form, on, text = "Enviando…") => {
    const btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!btn) return;
    if (on) {
      btn.dataset._origHtml = btn.tagName === "BUTTON" ? btn.innerHTML : btn.value;
      btn.disabled = true;
      form.setAttribute("aria-busy", "true");
      if (btn.tagName === "BUTTON") {
        btn.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>${text}`;
      } else {
        btn.value = text;
      }
    } else {
      btn.disabled = false;
      form.removeAttribute("aria-busy");
      if (btn.dataset._origHtml != null) {
        if (btn.tagName === "BUTTON") btn.innerHTML = btn.dataset._origHtml;
        else btn.value = btn.dataset._origHtml;
        delete btn.dataset._origHtml;
      }
    }
  };

  const wireForm = (form) => {
    // Evita cablear el mismo form dos veces
    if (form.dataset.mailerBound === "1") return;
    form.dataset.mailerBound = "1";

    const ds = form.dataset;
    const modalSel = ds.modal || "#myModal";
    const errorClass = ds.errorClass || "is-invalid";
    const required = (ds.required || "name,email,phone")
      .split(",").map((s) => s.trim().toLowerCase()).filter(Boolean);

    // ⬇️ Por defecto apunta a la raíz
    const endpoint = ds.endpoint || "/mailer.php";
    const autoCloseMs = parseInt(ds.autocloseMs || "2500", 10);

    const modalEl = document.querySelector(modalSel);
    const modal =
      modalEl && window.bootstrap && window.bootstrap.Modal
        ? new bootstrap.Modal(modalEl)
        : null;

    form.addEventListener("submit", async (ev) => {
      ev.preventDefault();

      // Honeypot anti-bot (si existe y tiene algo, aborta silenciosamente)
      const honey = form.querySelector('input[name="website"]');
      if (honey && honey.value && honey.value.trim() !== "") return;

      if (!validate(form, required, errorClass)) return;

      const payload = {
        formId: form.id,
        subject: ds.subject || "Consulta desde la web",
        name: (val(form, "name")?.value || "").trim(),
        email: (val(form, "email")?.value || "").trim(),
        phone: (val(form, "phone")?.value || "").trim(),
        city: (val(form, "city")?.value || "").trim(),
        message: (val(form, "message")?.value || "").trim(),
      };

      toggleSending(form, true, ds.sendingText || "Enviando…");

      try {
        const resp = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        let data;
        try {
          data = await resp.json();
        } catch (_) {
          data = { ok: false, msg: "Respuesta inválida del servidor." };
        }

        if (resp.ok && data.ok) {
          // 1) Cerrar el modal que contiene al formulario (si existe)
          const currentFormModalEl = form.closest(".modal");
          if (currentFormModalEl && window.bootstrap?.Modal) {
            const inst = bootstrap.Modal.getInstance(currentFormModalEl) || new bootstrap.Modal(currentFormModalEl);
            inst.hide();
          }

          // 2) Mostrar modal de éxito y resetear
          if (modal) modal.show();
          form.reset();

          if (typeof gtag === "function") {
            gtag("event", "form_submit", { form_id: form.id || "(sin-id)", result: "success" });
          }

          // 3) Auto-ocultar y recargar
          if (modal && modalEl) {
            setTimeout(() => { modal.hide(); }, autoCloseMs);
            modalEl.addEventListener("hidden.bs.modal", () => { location.reload(); }, { once: true });
          } else {
            setTimeout(() => location.reload(), autoCloseMs);
          }
        } else {
          alert((data && data.msg) || "No se pudo enviar el mensaje. Intente nuevamente.");
        }
      } catch (err) {
        alert("Error de red al enviar el mensaje.");
      } finally {
        toggleSending(form, false);
      }
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("form[data-mailer]").forEach(wireForm);
  });
})();
